import { Task } from "@lit/task";
import { DASHBOARD_CONFIG, dateAdd, toDateString } from "@pentacode/core";
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { app } from "../../../../init";
import { shared } from "../../../../styles";
import "../roster-gantt-chart";
import "./base-tile";

@customElement("ptc-dashboard-tile-shifts")
export class DashboardTileShifts extends LitElement {
    @property({ attribute: false })
    size: { inline: number; block: number } = app.settings.dashboard.tiles.shifts.size;

    static styles = [
        shared,
        css`
            :host {
                display: contents;
            }

            ptc-roster-gantt-chart {
                padding: 0;
            }
        `,
    ];

    private _shiftsTask = new Task(this, {
        task: async () => {
            const entries = await app.getTimeEntries({
                from: toDateString(new Date()),
                to: dateAdd(toDateString(new Date()), { days: 1 }),
            });
            return entries;
        },
        args: () => [],
    });

    render() {
        return html`
            <ptc-dashboard-tile
                label=${DASHBOARD_CONFIG.tiles.shifts.label}
                icon="icon.planning.shift"
                .size=${this.size}
                style="--tile-icon-color: var(--green)"
                tileType="shifts"
                @tile-size-change=${(e: CustomEvent) => {
                    this.size = e.detail.size;
                }}
            >
                ${this._shiftsTask.render({
                    initial: () => html``,
                    pending: () => html`
                        <ptc-ui-spinner
                            class="double-padded place-self-center"
                            active
                            style="font-size: 1rem"
                        ></ptc-ui-spinner>
                    `,
                    error: () =>
                        html`<div class="double-padded text-centering">Schichten konnten nicht geladen werden!</div>`,
                    complete: (entries) => {
                        if (entries.length === 0) {
                            return html`<div class="double-padded text-centering subtle place-self-center">
                                <span class="emoji huger">⛱️</span>
                                <p>Nichts für heute geplant – der Dienstplan gönnt sich eine Pause</p>
                            </div>`;
                        }
                        return html`<ptc-roster-gantt-chart .timeEntries=${entries}></ptc-roster-gantt-chart>`;
                    },
                })}
            </ptc-dashboard-tile>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ptc-dashboard-tile-shifts": DashboardTileShifts;
    }
}
